export default "__VITE_ASSET__941242bb__"